import React, {useEffect} from "react";
import {Card} from "antd";
import SearchForm from "./SearchForm";
import OrderList from "./OrderList";
import {useModelDispatchers} from "../../../models";

export default function () {
    const {
        getInvoiceTypeDict,
        getSaleOrderTypeDict,
        getSalePriceTypeDict,
        getSaleOrderStatusDict,
        getCustomerDict,
        getCustomerTypeDict,
        getOrgDict,
        getWarehouseDict,
        getAreaDict,
        getShelveDict,
        getPositionDict,
    } = useModelDispatchers("cmDict");

    useEffect(() => {
        getInvoiceTypeDict();
        getSaleOrderTypeDict();
        getSalePriceTypeDict();
        getSaleOrderStatusDict();
        getCustomerDict();
        getCustomerTypeDict();
        getOrgDict();
        getWarehouseDict();
        getAreaDict();
        getShelveDict();
        getPositionDict();
    }, []);
    const {init} = useModelDispatchers("saleOrder");
    useEffect(() => {
        init();
    }, [])
    return (
        <>
            <Card
                bordered={true}
                className="margin-top-8"
                style={{display: "flex"}}
            >
                <div
                    style={{
                        margin: "8px 20px"
                    }}
                >
                    <SearchForm/>
                </div>
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <OrderList/>
            </Card>
        </>
    )
}